function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path, Circle } from "react-native-svg";
var SvgWomenAndFamilyHealth = function SvgWomenAndFamilyHealth(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement(Path, {
    stroke: props.fillLine,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m12 21.368 5.095-5.096a3.09 3.09 0 0 0-2.18-5.286 3.1 3.1 0 0 0-2.187.919l-.728.727-.728-.727a3.088 3.088 0 1 0-4.367 4.367z"
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 12,
    cy: 6,
    r: 2.5,
    stroke: props.accentFillLine
  }));
};
export default SvgWomenAndFamilyHealth;